import { useState } from 'react';
import { makeStyles, Button, Menu, Avatar } from '@material-ui/core';
import cx from 'classnames';
import { ALL_ROUTES } from 'config/routes';
import MenuDivider from 'components/Shared/MenuDivider';
import CustomMenuItem from 'components/Shared/CustomMenuItem';
import { ReactComponent as LogoutIcon } from 'assets/icons/log_out.svg';
import { ReactComponent as ProfileIcon } from 'assets/icons/profile.svg';
import { ReactComponent as PasswordIcon } from 'assets/icons/password.svg';
import { useDispatch, useSelector } from 'react-redux';
import { logout, navigateToRoute } from '../../../../redux_store';

const useStyles = makeStyles((theme) => ({
  dropIcon: {
    position: 'absolute',
    right: 7,
    color: theme.palette.text.secondary,
  },
  blueBackground: {
    backgroundColor: theme.colors.lightBlue,
  },
  userAvatar: {
    width: 40,
    height: 40,
  },
  menuIcon: {
    width: 16,
    height: 16,
  },
}));

const UserMenu = ({ ...restProps }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { metadata: { currentAccount } } = useSelector((state) => state.user);
  const { en: { titles, nav } } = useSelector((state) => state.i18n);
  const { user } = useSelector((state) => state.user);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpenMenu = (e) => {
    setAnchorEl(e.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    handleCloseMenu();
    dispatch(navigateToRoute({ route: {
      path: ALL_ROUTES.login.path,
    }})).then(() => {
      dispatch(logout());
    });
  };

  const handleEditProfile = () => {
    handleCloseMenu();
    dispatch(navigateToRoute({ route: {
      path: ALL_ROUTES.profile.edit.path,
      title: titles.editProfile,
      clearBreadcrumbs: true,
      removeQueryString: true,
    }}));
  };

  const handleChangePassword = () => {
    handleCloseMenu();
    dispatch(navigateToRoute({ route: {
      path: ALL_ROUTES.profile.changePassword.path,
      title: titles.changePassword,
      clearBreadcrumbs: true,
      removeQueryString: true,
    }}));
  };
  const { firstName, lastName, photo } = user;

  return (
    <div {...restProps}>
      <Button
        aria-controls='user-menu'
        aria-haspopup='true'
        onClick={handleOpenMenu}
      >
        <Avatar
          src={photo}
          className={cx(
            (firstName || lastName) && classes.blueBackground,
            classes.userAvatar,
          )}
        >
          {firstName.charAt(0)}
          {lastName.charAt(0)}
        </Avatar>
      </Button>

      <Menu
        id='user-menu'
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        getContentAnchorEl={null}
      >
        <CustomMenuItem
          onClick={handleEditProfile}
          icon={ProfileIcon}
          iconClassName={classes.menuIcon}
        >
          {titles.editProfile}
        </CustomMenuItem>
        <CustomMenuItem
          onClick={handleChangePassword}
          icon={PasswordIcon}
          iconClassName={classes.menuIcon}
        >
          {titles.changePassword}
        </CustomMenuItem>
        <MenuDivider />
        <CustomMenuItem
          onClick={handleLogout}
          icon={LogoutIcon}
          iconClassName={classes.menuIcon}
        >
          {nav.logOut}
        </CustomMenuItem>
      </Menu>
    </div>
  );
};

export default UserMenu;
